/**
 * ReconnectingChip - Small chip shown when data refresh fails but cached data is displayed
 */

import React from 'react';

interface ReconnectingChipProps {
  message?: string;
  onRetry?: () => void;
}

export const ReconnectingChip: React.FC<ReconnectingChipProps> = ({
  message = 'Reconnecting...',
  onRetry,
}) => {
  return (
    <div className="flex items-center justify-center py-2">
      <div className="flex items-center space-x-2 px-3 py-1.5 bg-yellow-50 border border-yellow-200 rounded-full text-sm text-yellow-800">
        <svg
          className="animate-spin h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <span>{message}</span>
        {onRetry && (
          <button
            onClick={onRetry}
            className="ml-2 underline hover:no-underline font-medium"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
};
